/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Button,
  CircularProgress,
  Collapse,
  Typography
} from '@material-ui/core'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import moment from 'moment-jalaali'
import React, { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroller'

import { getTranslate, lang } from '../../localization'
import {
  BooleanFieldData,
  InventoryChannelType,
  InventoryRateplanType,
  NumberFieldData
} from '../../mockData/inventory'
import { Channel } from '../../types/channel'
import {
  ChannelInventoryData,
  MenuItemInInventory,
  ProviderAddon,
  RatePlanDetailsForEachDate
} from '../../types/inventory'
import CopyButton from './CopyButton'
import InventoryChannelRow from './InventoryChannelRow'
import InventoryChannelSelectionModal from './InventoryChannelSelectionModal'
import InventoryRowMenu from './InventoryRowMenu'
import { percentIncreaseDecreaseRegex } from './renderRows/RenderInputRowCell'
import RenderRowValues from './renderRows/RenderRowValues'
import useStyles from './styles/InventoryRoomtypeBox.styles'

interface InventoryRatePlanRowProps {
  ratePlanData: RatePlanDetailsForEachDate[]
  selectedInventoryFieldInRatePlan: MenuItemInInventory
  handleChangeSelectedInventoryFieldInRatePlan: (
    fieldType: MenuItemInInventory
  ) => void
  selectedInventoryFieldInChannel: MenuItemInInventory
  handleChangeSelectedInventoryFieldInChannel: (
    fieldType: MenuItemInInventory
  ) => void
  weekendIndexes: number[]
  roomName: string
  onSaveRowData?: (rowData: InventoryRateplanType) => void
  onCopyRatePlanForOtherRatePlans?: () => void
  availability: NumberFieldData[]
  ratePlanName: string
  channelsData: ChannelInventoryData[]
  displayRatePlanCode: string
  channels: Channel[]
  occupancy: number | 'def'
  hideZeroes: boolean
  range: 'TWO_WEEKS' | 'MONTH'
  defaultOccupancy: number
  addOns: ProviderAddon[]
}

const PAGE_SIZE = 10
export const typeOfMenuItems = (item: string) => {
  switch (item) {
    case 'price':
      return 'price'
    case 'availability':
      return 'number'
    case 'minStay':
      return 'number'
    case 'maxStay':
      return 'number'
    case 'closed':
      return 'boolean'
    case 'cta':
      return 'boolean'
    case 'ctd':
      return 'boolean'
    default:
      return 'price'
  }
}
const InventoryRatePlanRow: React.FC<InventoryRatePlanRowProps> = ({
  ratePlanData,
  defaultOccupancy,
  hideZeroes,
  selectedInventoryFieldInRatePlan,
  handleChangeSelectedInventoryFieldInRatePlan,
  selectedInventoryFieldInChannel,
  handleChangeSelectedInventoryFieldInChannel,
  weekendIndexes,
  roomName,
  onSaveRowData,
  onCopyRatePlanForOtherRatePlans,
  availability,
  ratePlanName,
  displayRatePlanCode,
  channelsData,
  channels,
  occupancy,
  range,
  addOns
}) => {
  const classes = useStyles()
  const [showChannels, setshowChannels] = useState(false)
  const [somethingHasBeenEdited, setsomethingHasBeenEdited] = useState(false)
  const menuItems: MenuItemInInventory[] = Object.keys(ratePlanData[0])
    .filter(
      (item) =>
        !['name', 'channels', 'date', 'availability', 'addOns'].includes(item)
    )
    .map((item) => ({
      label: item,
      code: item,
      type: typeOfMenuItems(item) as 'boolean' | 'number' | 'price'
    }))
    .concat(
      addOns.map((addon) => ({
        label:
          lang == 'fa'
            ? addon.nameTranslatedList.find(
                (name) => name.label === 'Iran, Islamic Republic of'
              )?.value || ''
            : addon.name,
        code: addon.code,
        type: 'price'
      }))
    )
  const [showChannelSelectionModel, setshowChannelSelectionModel] =
    useState(false)

  const [moreThanOneCellHasBeenModified, setmoreThanOneCellHasBeenModified] =
    useState(false)

  const [
    moreThanSevenCellHasBeenModified,
    setmoreThanSevenCellHasBeenModified
  ] = useState(false)

  const [numberOfVisibleChannels, setnumberOfVisibleChannels] =
    useState(PAGE_SIZE)

  // useEffect(() => {
  //   if (
  //     selectedInventoryFieldInRatePlan !== 'name' &&
  //     selectedInventoryFieldInRatePlan !== 'channels'
  //   ) {
  //     let numberOfModifiedCells = 0
  //     for (
  //       let i = 0;
  //       i < ratePlanData[selectedInventoryFieldInRatePlan].length;
  //       i += 1
  //     ) {
  //       if (ratePlanData[selectedInventoryFieldInRatePlan][i].edited) {
  //         if (numberOfModifiedCells === 0) {
  //           setsomethingHasBeenEdited(true)
  //         }
  //         numberOfModifiedCells += 1
  //       }
  //       if (numberOfModifiedCells > 1) {
  //         setmoreThanOneCellHasBeenModified(true)
  //       }
  //       if (numberOfModifiedCells > 7) {
  //         setmoreThanSevenCellHasBeenModified(true)
  //       }
  //     }
  //     if (numberOfModifiedCells < 2) {
  //       setmoreThanOneCellHasBeenModified(false)
  //     }
  //     if (numberOfModifiedCells < 8) {
  //       setmoreThanSevenCellHasBeenModified(false)
  //     }
  //   }
  // }, [ratePlanData])

  // const handleChangeChannelRowData = (
  //   newChannelRowData: InventoryChannelType,
  //   index: number
  // ) => {
  //   const newChannelsListRowsData = ratePlanData.channels
  //   newChannelsListRowsData[index] = newChannelRowData
  //   onSaveRowData({
  //     ...ratePlanData,
  //     channels: [...newChannelsListRowsData]
  //   })
  // }

  // const handleCopyRatePlanDataForOtherDays = (days: string[]) => {
  //   const ratePlanDataForSelectedField = ratePlanData[
  //     selectedInventoryFieldInRatePlan
  //   ] as NumberFieldData[] | BooleanFieldData[]

  //   for (let i = 0; i < ratePlanDataForSelectedField.length; i += 1) {
  //     if (ratePlanDataForSelectedField[i].edited) {
  //       const regexEdited =
  //         ratePlanDataForSelectedField[i].editedValue &&
  //         percentIncreaseDecreaseRegex.test(
  //           ratePlanDataForSelectedField[i].editedValue || ''
  //         )
  //       for (let j = 0; j < ratePlanDataForSelectedField.length; j += 1) {
  //         if (i === j) {
  //           // eslint-disable-next-line no-continue
  //           continue
  //         }
  //         if (days.includes(ratePlanDataForSelectedField[j].date)) {
  //           let newValue: number | boolean = 0
  //           if (regexEdited) {
  //             newValue =
  //               (ratePlanDataForSelectedField[j].value as number) +
  //               (ratePlanDataForSelectedField[j].value as number) *
  //                 (Number(
  //                   ratePlanDataForSelectedField[i].editedValue!.substring(
  //                     1,
  //                     ratePlanDataForSelectedField[i].editedValue!.length - 1
  //                   )
  //                 ) /
  //                   100) *
  //                 (ratePlanDataForSelectedField[i].editedValue!.charAt(0) ===
  //                 '+'
  //                   ? 1
  //                   : -1)
  //           } else {
  //             newValue = ratePlanDataForSelectedField[i].value
  //           }
  //           ratePlanDataForSelectedField[j] = {
  //             ...ratePlanDataForSelectedField[j],
  //             edited: true,
  //             value: newValue,
  //             // eslint-disable-next-line no-nested-ternary
  //             editedValue: regexEdited
  //               ? ratePlanDataForSelectedField[i].editedValue
  //               : typeof newValue === 'boolean'
  //               ? undefined
  //               : newValue.toString()
  //           }
  //         }
  //         if (ratePlanDataForSelectedField[j].date > days[days.length - 1]) {
  //           break
  //         }
  //       }
  //       break
  //     }
  //   }
  //   onSaveRowData(ratePlanData)
  // }

  // const handleCopyWeekDaysFromFirstSevenDays = (
  //   days: string[],
  //   weekDays: string[]
  // ) => {
  //   const ratePlanDataForSelectedField = ratePlanData[
  //     selectedInventoryFieldInRatePlan
  //   ] as NumberFieldData[] | BooleanFieldData[]
  //   for (
  //     let weekDayIndex = firstDayIndexInInventory;
  //     weekDayIndex < 7 + firstDayIndexInInventory;
  //     weekDayIndex += 1
  //   ) {
  //     if (
  //       weekDays.includes(
  //         moment(ratePlanDataForSelectedField[weekDayIndex].date).format('dddd')
  //       )
  //     ) {
  //       const regexEdited =
  //         ratePlanDataForSelectedField[weekDayIndex].editedValue &&
  //         percentIncreaseDecreaseRegex.test(
  //           ratePlanDataForSelectedField[weekDayIndex].editedValue || ''
  //         )
  //       for (
  //         let i = weekDayIndex + 7;
  //         i < ratePlanDataForSelectedField.length;
  //         i += 7
  //       ) {
  //         if (days.includes(ratePlanDataForSelectedField[i].date)) {
  //           let newValue: number | boolean = 0
  //           if (regexEdited) {
  //             newValue =
  //               (ratePlanDataForSelectedField[i].value as number) +
  //               (ratePlanDataForSelectedField[i].value as number) *
  //                 (Number(
  //                   ratePlanDataForSelectedField[
  //                     weekDayIndex
  //                   ].editedValue!.substring(
  //                     1,
  //                     ratePlanDataForSelectedField[weekDayIndex].editedValue!
  //                       .length - 1
  //                   )
  //                 ) /
  //                   100) *
  //                 (ratePlanDataForSelectedField[
  //                   weekDayIndex
  //                 ].editedValue!.charAt(0) === '+'
  //                   ? 1
  //                   : -1)
  //           } else {
  //             newValue = ratePlanDataForSelectedField[weekDayIndex].value
  //           }
  //           ratePlanDataForSelectedField[i] = {
  //             ...ratePlanDataForSelectedField[i],
  //             edited: true,
  //             value: newValue,
  //             // eslint-disable-next-line no-nested-ternary
  //             editedValue: regexEdited
  //               ? ratePlanDataForSelectedField[i].editedValue
  //               : typeof newValue === 'boolean'
  //               ? undefined
  //               : newValue.toString()
  //           }
  //         }
  //       }
  //     }
  //   }
  //   onSaveRowData(ratePlanData)
  // }

  // const handleCopyRatePlanDataForChannels = (selectedChannels: string[]) => {
  //   for (let i = 0; i < ratePlanData.channels.length; i += 1) {
  //     if (
  //       selectedChannels.includes(ratePlanData.channels[i].name) &&
  //       selectedInventoryFieldInRatePlan !== 'channels' &&
  //       selectedInventoryFieldInRatePlan !== 'name'
  //     ) {
  //       const channelSelectedFieldData = ratePlanData.channels[i][
  //         selectedInventoryFieldInRatePlan
  //       ] as NumberFieldData[] | BooleanFieldData[]

  //       for (let j = 0; j < channelSelectedFieldData.length; j += 1) {
  //         if (!ratePlanData[selectedInventoryFieldInRatePlan][j].edited) {
  //           // eslint-disable-next-line no-continue
  //           continue
  //         }
  //         const regexEdited =
  //           ratePlanData[selectedInventoryFieldInRatePlan][j].editedValue &&
  //           percentIncreaseDecreaseRegex.test(
  //             ratePlanData[selectedInventoryFieldInRatePlan][j].editedValue ||
  //               ''
  //           )
  //         let newValue: number | boolean = 0
  //         if (regexEdited) {
  //           newValue =
  //             (channelSelectedFieldData[j].value as number) +
  //             (channelSelectedFieldData[j].value as number) *
  //               (Number(
  //                 ratePlanData[selectedInventoryFieldInRatePlan][
  //                   j
  //                 ].editedValue!.substring(
  //                   1,
  //                   ratePlanData[selectedInventoryFieldInRatePlan][j]
  //                     .editedValue!.length - 1
  //                 )
  //               ) /
  //                 100) *
  //               (ratePlanData[selectedInventoryFieldInRatePlan][
  //                 j
  //               ].editedValue!.charAt(0) === '+'
  //                 ? 1
  //                 : -1)
  //         } else {
  //           newValue = ratePlanData[selectedInventoryFieldInRatePlan][j].value
  //         }
  //         channelSelectedFieldData[j] = {
  //           ...channelSelectedFieldData[j],
  //           value: newValue,
  //           edited: true
  //         }
  //       }
  //       // newRatePlanData.channels[i] = {
  //       //   ...newRatePlanData.channels[i],
  //       //   [selectedInventoryFieldInRatePlan]:
  //       // }
  //     }
  //   }
  //   onSaveRowData(ratePlanData)
  // }

  useEffect(() => {
    if (!showChannels) {
      setnumberOfVisibleChannels(PAGE_SIZE)
    }
  }, [showChannels])

  return (
    <>
      {/* {showChannelSelectionModel && (
        <InventoryChannelSelectionModal
          onClose={() => setshowChannelSelectionModel(false)}
          channels={ratePlanData.channels.map((item) => item.name)}
          onConfirm={handleCopyRatePlanDataForChannels}
        />
      )} */}
      <div
        className={[
          classes.ratePlanRow,
          range === 'MONTH' ? classes.ratePlanRowForMonth : ''
        ].join(' ')}>
        <div className={classes.rowNameContainer}>
          <div className={classes.roomIcon} />
          <div className={classes.rowName}>
            <Typography variant="h5" className={classes.rowNameTitle}>
              {ratePlanName}
            </Typography>
            <Typography
              variant="h6"
              className={classes.channel}
              component="span"
              onClick={() => setshowChannels(!showChannels)}>
              {
                channelsData.filter((channel) =>
                  channel.ratePlans.some(
                    (rp) =>
                      rp.basicDetails.displayRatePlanCode ===
                      displayRatePlanCode
                  )
                ).length
              }
              &nbsp;
              {getTranslate('CHANNELS')}
            </Typography>
            <ArrowRightIcon
              onClick={() => setshowChannels(!showChannels)}
              className={[
                classes.channelArrowRight,
                showChannels ? classes.channelArrowRightCollapsed : ''
              ].join(' ')}
            />
          </div>
          {/* {somethingHasBeenEdited && (
            <div className={classes.copyButtonContainer}>
              <CopyButton
                onCopyRatePlanDataForOtherDays={
                  handleCopyRatePlanDataForOtherDays
                }
                onCopyWeekDaysFromFirstSevenDays={
                  handleCopyWeekDaysFromFirstSevenDays
                }
                moreThanOneCellHasBeenModified={moreThanOneCellHasBeenModified}
                moreThanSevenCellHasBeenModified={
                  moreThanSevenCellHasBeenModified
                }
                onCopyRatePlanForOtherRatePlans={
                  onCopyRatePlanForOtherRatePlans
                }
                onCopyAcrossChannelsClicked={() => {
                  setshowChannelSelectionModel(true)
                }}
              />
            </div>
          )} */}
        </div>
        <div className={classes.dayContainer}>
          <InventoryRowMenu
            items={menuItems}
            onChangeSelectedItem={(newMenuItem) =>
              handleChangeSelectedInventoryFieldInRatePlan(
                newMenuItem as MenuItemInInventory
              )
            }
            activeItem={selectedInventoryFieldInRatePlan.label}
          />
          <ArrowRightIcon
            className={[
              classes.channelArrowRight,
              classes.channelArrowRightCollapsed
            ].join(' ')}
          />
        </div>
        <RenderRowValues
          rowData={ratePlanData}
          hideZeroes={hideZeroes}
          occupancy={occupancy}
          selectedInventoryField={selectedInventoryFieldInRatePlan}
          weekendIndexes={weekendIndexes}
          defaultOccupancy={defaultOccupancy}

          // onSaveRowData={(newRowData) => {
          //   onSaveRowData(newRowData as InventoryRateplanType)
          // }}
        />
      </div>
      <Collapse in={showChannels}>
        <div>
          <InfiniteScroll
            pageStart={0}
            loadMore={() => {
              setTimeout(() => {
                setnumberOfVisibleChannels(numberOfVisibleChannels + PAGE_SIZE)
              }, 500)
            }}
            hasMore={numberOfVisibleChannels <= channelsData.length - 1}
            loader={
              <div key={0} className={classes.loadingContainer}>
                <CircularProgress size={32} />
              </div>
            }
            useWindow={true}>
            {channelsData
              .slice(0, numberOfVisibleChannels)
              .filter((channel) =>
                channel.ratePlans.some(
                  (rp) =>
                    rp.basicDetails.displayRatePlanCode === displayRatePlanCode
                )
              )
              .map((channelItem: ChannelInventoryData, index) => (
                <InventoryChannelRow
                  key={channelItem.channelID}
                  channelData={channelItem?.ratePlans || []}
                  {...{
                    addOns,
                    selectedInventoryFieldInChannel,
                    handleChangeSelectedInventoryFieldInChannel,
                    weekendIndexes,
                    range,
                    defaultOccupancy,
                    hideZeroes,
                    occupancy,
                    availability,
                    displayRatePlanCode
                  }}
                  // onSaveRowData={(newRowData) => {
                  //   handleChangeChannelRowData(newRowData, index)
                  // }}
                  channelName={channelItem.channelName}
                />
              ))}
          </InfiniteScroll>
        </div>
      </Collapse>
    </>
  )
}

export default InventoryRatePlanRow
